import { render, staticRenderFns } from "./order-satisfaction-rate-history.vue?vue&type=template&id=59c13a35&scoped=true"
import script from "./order-satisfaction-rate-history.vue?vue&type=script&lang=js"
export * from "./order-satisfaction-rate-history.vue?vue&type=script&lang=js"
import style0 from "./order-satisfaction-rate-history.vue?vue&type=style&index=0&id=59c13a35&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c13a35",
  null
  
)

export default component.exports